import utils from './utils';

import style from './components/style';
import menu from './components/menu';
import slider from './components/slider';
import accordion from './components/accordion';
import map from './components/map';

function initHiPriorityCommon() {
}

function initLowPriorityCommon() {
    setTimeout(function() {
        
    }, 1000);
}

function initPage() {
	style.init();
	slider.init();
    menu.init();
    accordion.init();
    map.init();
}

// document.addEventListener( 'DOMContentLoaded', function () {
utils.domReady(function () {
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});
